import { Fragment, useCallback, useEffect, useState } from "react";
import { getAllBrand } from "../../../../apis/Brand";
import { getColorsbyKeyword } from "../../../../apis/Product";
import { getAllSeller } from "../../../../apis/Seller";
import { FormFieldGroup } from "./Form/FormFieldGroup";
import { ImageGallery } from "./Form/ImageGallery";

export const ParsedProductCard = ({
	product,
	category,
	setCategory,
	showCategory,
	setShowCategory,
	croppedFile,
	setCroppedFile,
	form,
}) => {
	const [images, setImages] = useState([]);

	const [sizes, setSizes] = useState([]);
	const { setValue, reset } = form;

	const setAutoCompleteObj = useCallback(async (name, value, fetchFunc) => {
		if (typeof value === "string") {
			const objs = await fetchFunc(value.toLowerCase());
			if (objs.success && objs.results.length) {
				const obj = objs.results.find(
					(obj) => obj.name.toLowerCase() === value.toLowerCase()
				);
				setValue(name, obj ? obj : "");
			}
		} else {
			setValue(name, value ? value : "");
		}
	}, [setValue]);

	useEffect(() => {
		if (!product) {
			reset(); // clears form
			setImages([]);
			setSizes("");
			setCategory(null);
			setCroppedFile(null);
			return;
		}

		const size_detail = product.sizes
			? product.sizes
			: product.size_detail
				? product.size_detail
				: "";
		setSizes(size_detail);
		reset({
			name: product.name || "",
			material: product.material || "",
			description: product.description || "",
			discount_price: product.discount_price || "",
			original_price: product.original_price || "",
			url: product.url || "",
			affiliated_url: product.affiliated_url || "",
			out_of_stock: product.out_of_stock || false,
			delivery: product.delivery || "",
			size_fit: product.size_fit || "",
			size_detail: JSON.stringify(size_detail) || "",
			product_category_id: product.product_category?.id || "",
			original_product_id: product.original_product_id || "",
			// gallery: product.gallery || [],
		});
		if (product.image) {
			setCroppedFile(product.image.file);
		}
		const imgs = product.gallery?.map?.((item) => {
			const isObject = typeof item === "object" && item !== null;

			if (isObject && "file" in item && "id" in item) {
				return {
					image: item.file,
					selected: true,
					id: item.id,
				};
			}

			// If it's a string or doesn't have expected keys, treat it as image string
			return {
				image: item,
				selected: true,
				id: null, // or you can use index
			};
		});
		console.log("imgs====================================", product.image);
		console.log(imgs, product.gallery);
		console.log("====================================");
		setImages(imgs);
		if (product.product_exist) {
			setCategory(product.product_category);
		}
		setAutoCompleteObj("seller", product.seller, getAllSeller);
		setAutoCompleteObj("brand", product.brand, getAllBrand);
		setAutoCompleteObj(
			"primary_color",
			product.primary_color ? product.primary_color : "",
			getColorsbyKeyword
		);
		setAutoCompleteObj(
			"secondary_color",
			product.secondary_color ? product.secondary_color : "",
			getColorsbyKeyword
		);
	}, [
		product,
		reset,
		setAutoCompleteObj,
		setCategory,
		setCroppedFile,
	]);

	useEffect(() => {
		if (category) {
			setValue("product_category_id", category.id);
		}
	}, [category, setValue]);

	return (
		<Fragment>
			<FormFieldGroup
				form={form}
				product={product}
				sizes={sizes}
				category={category}
				setCategory={setCategory}
				showCategory={showCategory}
				setShowCategory={setShowCategory}
			/>
			<ImageGallery
				product={product}
				images={images}
				setImages={setImages}
				form={form}
				croppedFile={croppedFile}
				setCroppedFile={setCroppedFile}
			/>
		</Fragment>
	);
};
